import { getConfigForLocale, KustomerConfig } from './ChatConfig'

declare const Kustomer: any

export let isKustomerChatEnabled = false

export function initializeChat(locale: string) {
  const kustomerConfig = getConfigForLocale(locale)
  if (kustomerConfig) {
    loadKustomerChat(kustomerConfig)
    window.onload = () => {
      removeBoldChat()
      replaceLiveChatContent(kustomerConfig.liveHelpText)
    }
  }
}

function removeBoldChat() {
  // Hide from main-site
  // this implementation should be improved, ylChat shouldn't be responsible to hide BoldChat
  const mainSiteBoldChat = document.querySelectorAll('a[href*="livechat.boldchat.com"]')
  if (mainSiteBoldChat) {
    mainSiteBoldChat.forEach(a => a.remove())
  }
}

function replaceLiveChatContent(newText: string){
  const liveChatDiv = document.getElementById('live-chat')
  if (liveChatDiv) {
    let icon = document.createElement("img")
    icon.src = "https://static.youngliving.com/Kustomer-Files/chat-icon_150x150_purple-solid.png"
    icon.width = icon.height = 30
    newText = newText.replace("[chat-icon]", icon.outerHTML)
    liveChatDiv.innerHTML = newText
  }
}

export function loadKustomerChat({ apiKey, brandId, assistantId, scheduleId, lang }: KustomerConfig) {
  isKustomerChatEnabled = true
  /* Load Kustomer */
  const script = document.createElement('script');
  script.setAttribute('src', 'https://cdn.kustomerapp.com/chat-web/widget.js');
  script.setAttribute('data-kustomer-api-key', apiKey);
  script.onload = () => {
    Kustomer.start({
      brandId,
      assistantId,
      scheduleId,
      lang
    },
      function (data: any) {
        Kustomer.addListener("onConversationCreate", (response: any, error: any) => {
          if (error) {
            console.log('[kustomer-chat] There was an error creating a listener (onConversationCreate).');
          }
          else {
            Kustomer.describeConversation({
              conversationId: response.conversationId,
              customAttributes: {
                isInternalBool: false,
                chatUrlStr: document.location.pathname,
              },
            });
          }
        });
      });
  };

  document.body.appendChild(script);
}
